'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utilsCombineReducers = require('./utils/combineReducers');

var _utilsCombineReducers2 = _interopRequireDefault(_utilsCombineReducers);

var _utilsCreateReducer = require('./utils/createReducer');

var _utilsCreateReducer2 = _interopRequireDefault(_utilsCreateReducer);

exports.combineReducers = _utilsCombineReducers2['default'];
exports.createReducer = _utilsCreateReducer2['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-immutablejs/lib/index.js
 ** module id = ./node_modules/redux-immutablejs/lib/index.js
 ** module chunks = 0
 **/